<h1>{{ "MCAuth.Header" | translate }}</h1>
<p>{{ "MCAuth.Detail" | translate }}</p>

<mat-button-toggle-group name="isAuthorizedUser" aria-label="label" vertical [(ngModel)]="mcIsAuthorizedUser">
  <mat-button-toggle [value]="true" class="green" (click)="canProceed()"
    ><mat-icon>check</mat-icon> {{ "Common.Yes" | translate }}</mat-button-toggle>
  <mat-button-toggle [value]="false" class="red" (click)="canProceed()"
    ><mat-icon>close</mat-icon> {{ "Common.No" | translate }}</mat-button-toggle>
</mat-button-toggle-group>
